import { alpha, makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  diagnosisBadge: {
    minWidth: 120,
    borderRadius: 5,
    padding: 8,
    fontSize: 14,
    fontWeight: 400,
    color: '#000',
    whiteSpace: 'nowrap'
  },

  diagnosisBadgePositivo: {
    backgroundColor: `${alpha(theme.palette.primary.main, 0.11)}`,
    border: `1px solid ${theme.palette.primary.main}`
  },

  diagnosisBadgeNegativo: {
    backgroundColor: 'rgba(244, 67, 54, 0.1)',
    border: '1px solid #F44336'
  },

  diagnosisBadgePendente: {
    backgroundColor: 'rgba(255, 193, 7, 0.1)',
    border: '1px solid #FFC107'
  },

  diagnosisBadgeIcon: {
    display: 'inline-flex',
    marginRight: 8,
    '& img': {
      width: 16,
      height: 16
    }
  }
}))
